import React, { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router";
import { Link } from "react-scroll";
import { UserInterfaceContext } from "../userInterfaceContext";
import Iframe from "../reuseables/iframe";
import trinityLogo from "../images/tirinity.jpg";
import motownlogo from "../images/motown.png";
import knustlogo from "../images/knustlogo.png";
import uoedin from "../images/uoe_logo_bw.png";
import edinpic from "../images/EDIN.jpg";
import mastercardlogo from "../images/mastercard.svg";
import oaalogo from "../images/OAA.jpg";
import ghhighwaylogo from "../images/ghhighwayauth.jpg";
import ifixlogo from "../images/ifix logo.png";
import lightlogo from "../images/lightofworld.png";
import starlogo from "../images/star.png";
import researchlogo from "../images/research.svg";
import frontendLogo from "../images/pngtree-back-end-developer-flat-icon-vector-png-image_7082926.png";
import backendLogo from "../images/6213731.png";
import uiuxLogo from "../images/6052069.png";
import hardwareLogo from "../images/10425318.png";
import networkLogo from "../images/4152018.png";
import databaseLogo from "../images/2232137.png";

import lingualogo from "../images/lingua.png";
import aimlogo from "../images/aimproject.jpg";
import softesclogo from "../images/softesc.png";
import loftlogo from "../images/loftworld.png";
import mastercard from "../images/mastercard.svg";
// import Resume from "../reuseables/WILLIAM ETORNAM GOKU_RESUME FEB 2024.pdf";
import { FiExternalLink, FiMail } from "react-icons/fi";
import {
  SiReact,
  SiBootstrap,
  SiMicrosoftdotnet,
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiNodedotjs,
  SiExpress,
  SiDotnet,
  SiMongodb,
  SiMicrosoftsqlserver,
  SiFigma,
  SiAdobephotoshop,
  SiWordpress

} from "react-icons/si";
import { MdSpeed, MdBuild, MdSettings } from "react-icons/md";
import { FaNetworkWired } from "react-icons/fa";
import {
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaTelegram,
  FaYoutube,
} from "react-icons/fa";

import {
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiJavascript1,
} from "react-icons/di";
import { SiCsharp } from "react-icons/si";
import myPicture from "../images/mee.png";
import trinitypic from "../images/trinitypic.jpg";
import achimotapic from "../images/achimota-school-1716495105.webp";
import knustpic from "../images/knustpic.jpeg";
function Me() {
  const {
    showIframe,
    setShowIframe,
    frameLink,
    setFrameLink,
    frameName,
    setFrameName,
    setFrameLogo,
    projects,
    projectDetails,
    setProjectDetails,
    projectCode,
    setProjectCode,
  } = useContext(UserInterfaceContext);
  const [isEmailInputActive, setEmailInputActive] = useState(false);
  const [isPasswordInputActive, setPasswordInputActive] = useState(false);
  const [activePlaceholder, setActivePlaceholder] = useState("");

  const [masterId, setMasterId] = useState("");
  const [passkey, setPasskey] = useState("");

  const handleFocus = (placeholder, type) => {
    if (type === "email") {
      setEmailInputActive(true);
      setPasswordInputActive(false);
    } else if (type === "passkey") {
      setPasswordInputActive(true);
      setEmailInputActive(false);
    }
    setActivePlaceholder(placeholder);
  };

  // const [frameName, setFrameName] = useState("");

  const [toggleMenu, setToggleMenu] = useState(true);
  const [screenMode, setScreenMode] = useState(
    window.innerWidth <= 980 ? "small" : "large"
  );

  useEffect(() => {
    const updateScreenMode = () => {
      if (window.innerWidth <= 980) {
        setScreenMode("small");
      } else {
        setScreenMode("large");
      }
    };
    updateScreenMode();
    window.addEventListener("resize", updateScreenMode);
    return () => {
      window.removeEventListener("resize", updateScreenMode);
    };
  }, []);

  const texts = [
    "RESEARCH🔬",
    "BUSINESS💼",
    "TECH💻",
    "HARDWARE⚙️",
    "WEBDEV🌐",
    "AI🧠",
    "STARTUPS🚀",
  ];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [texts.length]);

  return (
    <div className="Home">
      <div className="ddd"></div>
      <div className="stack-social-links">
        <a
          href="https://github.com/williamifix"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
        >
          <FaGithub />
        </a>
        <a
          href="www.linkedin.com/in/william-goku-126994222"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
        >
          <FaLinkedin />
        </a>
        <a
          href="mailto:wgoku885@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
        >
          <FiMail />
        </a>
        <a
          href="https://twitter.com/yourusername"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
        >
          <FaTwitter />
        </a>

        <a
          href="https://wa.me/+233552851039"
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
        >
          <FaWhatsapp />
        </a>
      </div>
      <div className="container">
        <div
          style={!toggleMenu ? { width: "100vw" } : { width: "0vw" }}
          className="side-menu-back-filter"
          onClick={() => {
            setToggleMenu(true);
          }}
        ></div>
        <Iframe link={frameLink} />

        <div className="navbar">
         <div className="inner">
           <div className="logo">
            <span> @william_goku</span>
          </div>
          <div
            className={screenMode === "large" ? "links" : "sideLinks"}
            style={{
              width: toggleMenu && screenMode === "small" ? "0rem" : "20rem",
            }}
          >
            <Link
              className="link"
              to="about"
              smooth={true}
              duration={500}
              spy={true}
              offset={-50}
              activeClass="active"
              onClick={() => {
                setToggleMenu(true);
              }}
            >
              Me
            </Link>
            <Link
              className="link"
              to="research-interest"
              smooth={true}
              duration={500}
              spy={true}
              offset={-50}
              activeClass="active"
              onClick={() => {
                setToggleMenu(true);
              }}
            >
              Research
            </Link>
            {/* <Link
              className="link"
              to="education"
              smooth={true}
              duration={500}
              spy={true}
              offset={-50}
              activeClass="active"
              onClick={() => {
                setToggleMenu(true);
              }}
            >
              Education
            </Link>
            <Link
              className="link"
              to="achievement"
              smooth={true}
              duration={500}
              spy={true}
              offset={-50}
              activeClass="active"
              onClick={() => {
                setToggleMenu(true);
              }}
            >
              Awards
            </Link> */}
            <Link
              className="link"
              to="work"
              smooth={true}
              duration={500}
              spy={true}
              offset={-50}
              activeClass="active"
              onClick={() => {
                setToggleMenu(true);
              }}
            >
              Work
            </Link>
            <Link
              className="link"
              to="project"
              smooth={true}
              duration={500}
              spy={true}
              offset={-50}
              activeClass="active"
              onClick={() => {
                setToggleMenu(true);
              }}
            >
              Projects
            </Link>
            <Link
              className="link"
              to="skill"
              smooth={true}
              duration={500}
              spy={true}
              offset={-50}
              activeClass="active"
              onClick={() => {
                setToggleMenu(true);
              }}
            >
              Skills
            </Link>
            {/* <Link
              className="link"
              to="certificate"
              smooth={true}
              duration={500}
              spy={true}
              offset={-50}
              activeClass="active"
              onClick={() => {
                setToggleMenu(true);
              }}
            >
              Certifications
            </Link> */}

            <a
              className="link"
              href="/WILLIAM ETORNAM GOKU_RESUME FEB 2024.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              My Résumé
            </a>
          </div>
          {screenMode === "small" ? (
            <div
              className="menu-icon"
              onClick={() => {
                setToggleMenu(!toggleMenu);
              }}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          ) : null}
         </div>
        </div>
        <div className="about-container" id="about">
          <div className="me">
            <div className="about-me">
              <h3 className="my-name">I'm William Etornam Goku</h3>
              <span className="sub-name">
                CONNECT LET'S DO -
                <b className="text-container">
                  {texts.map((text, index) => (
                    <b
                      key={index}
                      className={`text-box ${
                        index === currentIndex ? "active" : ""
                      }`}
                    >
                      {text}
                    </b>
                  ))}
                </b>
              </span>

              <p>
                I am a passionate software developer and{" "}
                <b>an aspiring researcher</b> with a strong foundation in
                Computer Science concepts. I specialize in
                <b> full-stack web development</b> ,{" "}
                <b>Networking and security</b> , and
                <b> Computer Architecture</b>. My research interests lie in
                <b>Network & Security</b> ,<b> Computer Architecture</b> , and{" "}
                <b>Artificial Intelligence</b> . Beyond coding, I am committed
                to mentorship, accessibility advocacy, and using technology to
                drive positive social change. Explore my projects to see how we
                could collaborate in the future.
              </p>

              <Link
                className="button"
                to="contact"
                smooth={false}
                duration={500}
                spy={true}
                offset={-50}
                activeClass="active"
              >
                CONTACT ME
              </Link>
              {/* <button>CONTACT ME</button> */}
            </div>
            <div className="my-picture">
              <div className="background">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <img src={myPicture} alt="" />
            </div>
          </div>
        </div>
        <div className="body-container">
          <div
            className="section-container dark-theme-bg"
            id="research-interest"
          >
            <div className="sec-header" style={{ opacity: "0" }}>
              .
            </div>
            <div className="section">
              <div className="sec-header">RESEARCH INTEREST</div>
              <div className="edu-body">
                {/* 🔧 Computer Hardware Optimization */}
                <div className="school">
                  <div className="sch-logo">
                    <img src={researchlogo} alt="icon" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      Computer Hardware Optimization and Efficiency
                    </span>
                    <span className="sch-year justify">
                      Optimizing cache and memory hierarchies in CPUs/GPUs to
                      reduce energy consumption while improving speed.
                      Investigating novel cache replacement policies and memory
                      access patterns for data-intensive workloads.
                    </span>
                  </div>
                </div>

                <div className="school">
                  <div className="sch-logo">
                    <img src={researchlogo} alt="icon" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      Hardware-Software Co-Design for Accelerated AI and
                      Rendering-Intensive Workloads
                    </span>
                    <span className="sch-year justify">
                      Developing coordinated approaches to distribute AI tasks
                      across CPUs, GPUs, and NPUs. Creating intelligent
                      scheduling algorithms that optimize for both energy
                      efficiency and computational throughput in heterogeneous
                      systems.
                    </span>
                  </div>
                </div>

                {/* 🛰️ Satellite-Based Network Security */}
                <div className="school">
                  <div className="sch-logo">
                    <img src={researchlogo} alt="icon" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      Secure Satellite-Based Internet and Communications
                    </span>
                    <span className="sch-year justify">
                      Developing and testing post-quantum encryption methods
                      (lattice-based, hash-based) tailored for space
                      environments. Evaluating their performance impact on
                      satellite communication latency and bandwidth.
                    </span>
                  </div>
                </div>

                <div className="school">
                  <div className="sch-logo">
                    <img src={researchlogo} alt="icon" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      AI-Powered Threat Detection in Networks Architecture
                      Systems
                    </span>
                    <span className="sch-year justify">
                      Applying machine learning models to monitor and detect
                      intrusions in real-time across dynamic network systems and
                      topologies. Developing lightweight anomaly detection
                      algorithms suitable for resource-constrained satellite
                      payloads.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="section-container" id="education">
            <div className="section">
              <div className="sec-header">EDUCATION</div>
              {/* <div className="edu-body">
                <div className="school">
                  <a
                    href="https://www.knust.edu.gh/"
                    className="pro-external-link"
                  >
                    <FiExternalLink className="external-link-icon" />{" "}
                  </a>

                  <div className="sch-logo">
                    <img src={knustlogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      KWAME NKRUMAH UNIVERSITY OF SCIENCE and TECHNOLOGY
                    </span>
                    <span className="sch-year">2020 - 2024</span>
                    <span className="sch-cert">BSc. COMPUTER SCIENCE</span>
                  </div>
                </div>
                <div className="school">
                  <a
                    href="https://www.achimota.edu.gh/"
                    className="pro-external-link"
                  >
                    <FiExternalLink className="external-link-icon" />{" "}
                  </a>
                  <div className="sch-logo">
                    <img src={motownlogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">ACHIMOTA SCHOOL</span>
                    <span className="sch-year">2016 - 2019</span>
                    <span className="sch-cert">
                      WEST AFRICAN SECONDARY SCHOOL CERTIFICATE EXAMINATION
                      (WASSCE)
                    </span>
                  </div>
                </div>
                <div className="school">
                  <a href="" className="pro-external-link">
                    <FiExternalLink className="external-link-icon" />{" "}
                  </a>
                  <div className="sch-logo">
                    <img src={trinityLogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">TRINITY ACADEMY SCHOOL</span>
                    <span className="sch-year">2010 - 2016</span>
                    <span className="sch-cert">
                      BASIC EDUCATION CERTIFICATE EXAMINATION (BECE)
                    </span>
                  </div>
                </div>
              </div> */}

              <div className="education">
                <div className="edu">
                  <img src={edinpic} alt="" />
                  <div className="edu-details">
                    <img src={uoedin} alt="" />
                    <div>
                      <span>
                        The University Of Edinburgh , UK
                      </span>
                      <span>2026 - DATE </span>
                      <span>MSc. Data Science Technologies</span>
                    </div>
                  </div>
                </div>
                <div className="edu">
                  <img src={knustpic} alt="" />
                  <div className="edu-details">
                    <img src={knustlogo} alt="" />
                    <div>
                      <span>
                        KWAME NKRUMAH UNIVERSITY OF SCIENCE AND TECHNOLOGY
                      </span>
                      <span>2020 - 2024 </span>
                      <span>BSc. Computer Science</span>
                    </div>
                  </div>
                </div>
                <div className="edu">
                  <img src={achimotapic} alt="" />
                  <div className="edu-details">
                    <img src={motownlogo} alt="" />
                    <div>
                      <span>ACHIMOTA SCHOOL</span>
                      <span>2016 - 2019</span>
                      {/* <span>Senior High School</span> */}
                      <span>SHS - General Science - W.A.S.S.C.E</span>
                    </div>
                  </div>
                </div>
                {/* <div className="edu">
                  <img src={trinitypic} alt="" />
                  <div className="edu-details">
                    <img src={trinityLogo} alt="" />
                    <div>
                      <span>TRINITY ACADEMY </span>
                      <span>2014 - 2016 </span>
                      <span>JHS - B.E.C.E</span>
                    </div>
                  </div> */}
                {/* </div> */}
              </div>
              <br />
              {/* <br /> */}
              {/* <div className="sec-header">HONORS | AWARDS</div> */}
              {/* <hr /> */}
              {/* <br /> */}
              <div className="edu-body">
                <div className="school">
                  <a href="" className="pro-external-link">
                    <FiExternalLink className="external-link-icon" />{" "}
                  </a>
                  <div className="sch-logo">
                    <img src={mastercardlogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      MASTERCARD FOUNDATION SCHOLARS' PROGRAM AT UNIVERSITY OF EDINBURGH
                    </span>
                    <span className="sch-year">2026 - 2029</span>
                    <span className="sch-cert">
                      FULL SCHOLARSHIP - SOCIAL IMPACT / MERIT BASED
                    </span>
                  </div>
                </div>
                <div className="school">
                  <a href="" className="pro-external-link">
                    <FiExternalLink className="external-link-icon" />{" "}
                  </a>
                  <div className="sch-logo">
                    <img src={mastercardlogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      MASTERCARD FOUNDATION SCHOLARS' PROGRAM AT KNUST
                    </span>
                    <span className="sch-year">2020 - 2024</span>
                    <span className="sch-cert">
                      FULL SCHOLARSHIP - SOCIAL IMPACT / MERIT BASED
                    </span>
                  </div>
                </div>
                <div className="school">
                  <a
                    href="https://oldachimotan.org/"
                    className="pro-external-link"
                  >
                    <FiExternalLink className="external-link-icon" />{" "}
                  </a>
                  <div className="sch-logo">
                    <img src={oaalogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      OLD ACHIMOTAN ASSOCIATION SCHOLARSHIP
                    </span>
                    <span className="sch-year">2016 - 2019</span>
                    <span className="sch-cert">
                      FULL SCHOLARSHIP - MERIT BASED
                    </span>
                  </div>
                </div>
                {/* <div className="school">
                  <a href="" className="pro-external-link">
                    <FiExternalLink className="external-link-icon" />{" "}
                  </a>
                  <div className="sch-logo">
                    <img src={trinityLogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      TRINITY ACADEMY SCHOOL BURSARY
                    </span>
                    <span className="sch-year">2014 - 2016</span>
                    <span className="sch-cert">FULL SCHOLARSHIP</span>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className="section-container dark-theme-bg" id="work">
            <div className="section">
              <div className="sec-header">WORK EXPERIENCE | ROLES</div>
              <div className="edu-body">
                <div className="school">
                  <div className="sch-logo">
                    <img src={mastercardlogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      E-LEARNING INITIATIVE - MASTERCARD FOUNDTION SCHOLARS PROGRAM AT KNUST
                    </span>
                    <span className="sch-year">09/2025 - DATE</span>
                    <span className="sch-cert">
                      CONTRACT STAFF - SOFTWARE DEVELOPER AND TECHNICAL SUPPORT
                    </span>
                  </div>
                </div>
                <div className="school">
                  <div className="sch-logo">
                    <img src={knustlogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">
                      NETWORK OPERATIONS AND INFRASTRUCTURE DEPARTMENT (NOID) -
                      KNUST UITS
                    </span>
                    <span className="sch-year">09/2024 - 08/2025</span>
                    <span className="sch-cert">NATIONAL SERVICE PERSON</span>
                  </div>
                </div>
                <div className="school">
                  <div className="sch-logo">
                    <img src={lightlogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">LIGHT OF THE WORLD SCHOOL</span>
                    <span className="sch-year">CONTRACT [2025]</span>
                    <span className="sch-cert">
                      Designed and developed a school website and management
                      system
                    </span>
                  </div>
                </div>
                <div className="school">
                  <div className="sch-logo">
                    <img src={ifixlogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">IFIX COMPUTER SERVICES</span>
                    <span className="sch-year">FULL-TIME [2022 - DATE]</span>
                    <span className="sch-cert">
                      Personal IT startup for Computer Servicing and
                      Troubleshooting.
                    </span>
                  </div>
                </div>

                <div className="school">
                  <div className="sch-logo">
                    <img src={starlogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">STAR OF THE EAST SCHOOL</span>
                    <span className="sch-year">CONTRACT [2024]</span>
                    <span className="sch-cert">
                      Designed and developed a school website and management
                      system
                    </span>
                  </div>
                </div>
                <div className="school">
                  <div className="sch-logo">
                    <img src={ghhighwaylogo} alt="" />
                  </div>
                  <div className="sch-details">
                    <span className="sch-name">GHANA HIGHWAY AUTHORITY</span>
                    <span className="sch-year">
                      INTERNSHIP - [OCT - DEC, 2020]
                    </span>
                    <span className="sch-cert">
                      Data collection, Networking and IT support for
                      administration
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section-container" id="project">
            <div className="section">
              <span className="sec-header">PROJECTS</span>
              <div className="sec-body">
                   <div className="project-container">
                  <div className="project">
                    <div className="pro-header">
                      <span className="project-logo">
                        <img src={lingualogo} alt="" />
                      </span>
                      <a
                      target="blank"
                      href="https://www.edusyncghana.com/"
                        className="pro-external-link"
                       
                      >
                        <FiExternalLink className="external-link-icon" />{" "}
                      </a>
                    </div>
                    <span className="pro-title">EDUSYNC GHANA</span>
                    <p>
                      An AI-powered school management system for efficiently managing
                      students, administration, academic and accounting operations.
                    </p>
                     <div className="pro-footer"
                      onClick={() => {
                          setFrameLink(
                            projects.find(
                              (projects) => projects.code === "EDU-SYNC GHANA"
                            ).demoLink
                          );
                          setShowIframe(true);
                          setFrameName("EDU-SYNC GHANA");
                          setFrameLogo(lingualogo);
                          setProjectDetails(
                            projects.find(
                              (projects) => projects.code === "EDU-SYNC GHANA"
                            )
                          );
                        }}
                        >
                     <p>Check it out</p>
                    </div>
                  </div>
                </div>
               

                  <div className="project-container">
                  <div className="project">
                    <div className="pro-header">
                      <span className="project-logo">
                        <img src={lingualogo} alt="" />
                      </span>
                      <a
                      target="blank"
                      href="https://www.ifixcampus.com/"
                        className="pro-external-link"                       
                      >
                        <FiExternalLink className="external-link-icon" />{" "}
                      </a>
                    </div>
                    <span className="pro-title">IFIX CAMPUS</span>
                    <p>
                      A IT solutions provider for schools and organizations — covering everything from web development to hardware, networking, and training.
                    </p>
                    <div className="pro-footer"
                     onClick={() => {
                          setFrameLink(
                            projects.find(
                              (projects) =>
                                projects.code === "IFIX-CAMPUS"
                            ).demoLink
                          );
                          setShowIframe(true);
                          setFrameName("IFIX-CAMPUS");
                          setFrameLogo(lingualogo);
                          setProjectDetails(
                            projects.find(
                              (projects) =>
                                projects.code === "IFIX-CAMPUS"
                            )
                          );
                        }}
                        >
                     <p>Check it out</p>
                    </div>
                  </div>
                </div>


                <div className="project-container">
                  <div className="project">
                    <div className="pro-header">
                      <span className="project-logo"> 
                        <img src={lingualogo} alt="" />
                      </span>
                      <a
                      target="blank"
                      href="https://linguaconnect.vercel.app/"
                        className="pro-external-link"                       
                      >
                        <FiExternalLink className="external-link-icon" />{" "}
                      </a>
                    </div>
                    <span className="pro-title">LINGUA CONNECT</span>
                    <p>
                      A multilingual communication web app for messaging and
                      translation, bridging language barriers in diverse
                      communities.
                    </p>
                     <div className="pro-footer"
                      onClick={() => {
                          setFrameLink(
                            projects.find(
                              (projects) => projects.code === "LINGUA-CONNECT"
                            ).demoLink
                          );

                          setShowIframe(true);
                          setFrameName("LINGUA-CONNECT");
                          setFrameLogo(lingualogo);
                          setProjectDetails(
                            projects.find(
                              (projects) => projects.code === "LINGUA-CONNECT"
                            )
                          );
                        }}
                        >
                     <p>Check it out</p>
                    </div>
                  </div>
                </div>

             
              </div>
            </div>
          </div>

          <div className="section-container dark-theme-bg" id="skill">
            <div className="section">
              <div className="sec-header">SKILLS AND STACKS</div>
              <div className="techstacks">
                <div className="stack-container">
                  <div className="stack">
                    <div className="stack-header">
                      <div className="img">
                        <img src={frontendLogo} alt="" />
                      </div>
                      <span className="stack-name">FRONTEND</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <SiReact />
                      </span>
                      <span>React.JS</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <SiBootstrap />
                      </span>
                      <span>Bootstrap</span>
                    </div>

                    <div className="stack-details">
                      <span className="item-img">
                        <SiDotnet />
                      </span>
                      <span>Razor | MVC </span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <SiHtml5 />
                      </span>
                      <span>HTML | CSS | JS</span>
                    </div>
                  </div>
                </div>
                <div className="stack-container">
                  <div className="stack">
                    <div className="stack-header">
                      <div className="img">
                        <img src={backendLogo} alt="" />
                      </div>
                      <span className="stack-name">BACKEND</span>
                    </div>

                    <div className="stack-details">
                      <span className="item-img">
                        <SiNodedotjs />
                      </span>
                      <span>Node JS</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <SiExpress />
                      </span>
                      <span>Express JS</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <SiDotnet />
                      </span>
                      <span>MVC</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <SiDotnet />
                      </span>
                      <span>ASP .NET Core</span>
                    </div>
                  </div>
                </div>
                <div className="stack-container">
                  <div className="stack">
                    <div className="stack-header">
                      <div className="img">
                        <img src={databaseLogo} alt="" />
                      </div>
                      <span className="stack-name">DATABASE</span>
                    </div>

                    <div className="stack-details">
                      <span className="item-img">
                        <SiMongodb />
                      </span>
                      <span>MongoDB</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <SiDotnet />
                      </span>
                      <span>Microsoft SQL</span>
                    </div>
                  </div>
                </div>
                {/* <div className="stack-container">
                  <div className="stack">
                    <div className="stack-header">
                      <div className="img">
                        <img src={uiuxLogo} alt="" />
                      </div>
                      <span className="stack-name">UI / UX</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <SiFigma />
                      </span>
                      <span>Figma</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <SiAdobephotoshop />
                      </span>
                      <span>Photoshop</span>
                    </div>
                  </div>
                </div> */}
                <div className="stack-container">
                  <div className="stack">
                    <div className="stack-header">
                      <div className="img">
                        <img src={hardwareLogo} alt="" />
                      </div>
                      <span className="stack-name">COMPUTER HARDWARE</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <MdSpeed />
                      </span>
                      <span>OPTIMIZATION </span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <MdBuild />
                      </span>
                      <span>TROUBLESHOOTING</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <MdSettings />
                      </span>
                      <span>REPAIRS & SERVICING</span>
                    </div>
                  </div>
                </div>
                {/* <div className="stack-container">
                  <div className="stack">
                    <div className="stack-header">
                      <div className="img">
                        <img src={networkLogo} alt="" />
                      </div>
                      <span className="stack-name">NETWORK & SECURITY</span>
                    </div>
                    <div className="stack-details">
                      <span className="item-img">
                        <FaNetworkWired />
                      </span>
                      <span>Server Installation</span>
                    </div>
                  </div> */}
                {/* </div> */}
              </div>
            </div>
          </div>

          <div className="section-container" id="certificates">
            <div className="section">
              <div className="sec-header">
                <span>CERTIFICATIONS</span>
              </div>
              <p>... Still compiling all cert docs. Give me some time</p>
            </div>
          </div>
          <div className="section-container dark-theme-bg" id="contact">
            <div className="section">
              <div className="messager">
                <div className="info">
                  <FaTelegram className="messager-icon" />
                  <span style={{ color: "white" }}>
                    Send me a direct Message
                  </span>
                  <div className="social-links">
                    <a
                      href="https://github.com/williamifix"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                    >
                      <FaGithub />
                    </a>
                    <a
                      href="www.linkedin.com/in/william-goku-126994222"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                    >
                      <FaLinkedin />
                    </a>
                    <a
                      href="mailto:wgoku885@gmail.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                    >
                      <FiMail />
                    </a>
                    <a
                      href="https://twitter.com/yourusername"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                    >
                      <FaTwitter />
                    </a>

                    <a
                      href="https://wa.me/+233552851039"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-link"
                    >
                      <FaWhatsapp />
                    </a>
                  </div>
                </div>
                {/* <hr /> */}
                {/* <div className="form">
                  <div className="input">
                    <input type="text" placeholder="Enter your address here" />
                  </div>
                  <div className="input">
                    <textarea
                      name=""
                      id=""
                      placeholder="Type your message here"
                    ></textarea>
                  </div>
                  <button>
                    Send Message <FaTelegram />{" "}
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="">
            <a
              href="https://github.com/williamifix"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <FaGithub />
            </a>
            <a
              href="www.linkedin.com/in/william-goku-126994222"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <FaLinkedin />
            </a>
            <a
              href="mailto:wgoku885@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <FiMail />
            </a>
            <a
              href="https://twitter.com/yourusername"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <FaTwitter />
            </a>

            <a
              href="https://wa.me/+233552851039"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <FaWhatsapp />
            </a>
          </div>
          <p>Copyright © {new Date().getFullYear()} WILLIAM ETORNAM GOKU</p>
        </div>
      </div>
    </div>
  );
}

export default Me;
